const modalOrderLine = {
  LineIndex: "0",
  LinePk: "",
  LineFk: "",
  LineNumber: "",
  LinePartNumber: "",
  LinePartNumberPK: "",
  LineDescription: "",
  LineQuantity: "",
  LineInvoicedQuantity: "",
  LineRecievedQuantity: "",
  LineRemainingQuantity: "",
  UnitOfQuantity: { Unit: "", Description: "" },
  LineItemPrice: "",
  LineTotalPrice: "",
  LineIncoTerms: { Code: "", Description: "" },
  LineAdditionalTerms: "",
  LineConfirmNumber: "",
  LineConfirmDate: "",
  LineInnerPacks: "",
  LineInnerPacksUnit: { Code: "", Description: "" },
  LineOuterPacks: "",
  LineOuterPacksUnit: { Code: "", Description: "" },
  LineActualVolume: "",
  LineUnitOfVolume: { Unit: "", Description: "" },
  LineActualWeight: "",
  LineUnitOfWeight: { Unit: "", Description: "" },
  LineOuterPacksLength: "",
  LineOuterPacksHeight: "",
  LineOuterPacksWidth: "",
  UnitOfDimension: { Unit: "", Description: "" },
  LineReqExWorkDate: "",
  LineReqInStoreDate: ""
};

export default modalOrderLine;
